<template>
  <head>
    <meta charset="utf-8" />
    <title>HOSPITAL MANAGEMENT INFORMATION SYSTEM | Your contact List</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Keep your finances and membership up to date" name="description" />
    <meta content="Kelvin Njuguna Ndungu" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">

    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="main-content">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Users Register</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item active">User's Register</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Error Alert -->
          <div v-if="alert.failed" class="alert alert-danger alert-dismissible fade show" role="alert">
            <i class="mdi mdi-alert-outline me-2"></i>
            {{ message }}
            <button type="button" class="btn-close" @click="alert.failed = false"></button>
          </div>

          <!-- Success Alert -->
          <div v-if="alert.success" class="alert alert-success alert-dismissible fade show" role="alert">
            <i class="mdi mdi-check-all me-2"></i>
            {{ message }}
            <button type="button" class="btn-close" @click="alert.success = false"></button>
          </div>

          <!-- eTransactions table -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <h4 class="mb-0">Registered Users</h4>
                    <div class="d-flex">
                    </div>
                  </div>
                  <div class="btn-toolbar p-3 align-items-center d-none animated delete-tool-bar" role="toolbar">
                    <button type="button" class="btn btn-primary waves-effect btn-label waves-light me-3"><i class="bx  bx-trash label-icon"></i> Delete Contact(s)</button>
                    <button type="button" class="btn btn-primary waves-effect btn-label waves-light me-3"><i class="mdi mdi-plus label-icon"></i> Compose Message</button>
                  </div>
                </div>
                <div class="card-body">
                  <!-- Search and Filter Section -->
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <div class="search-box">
                        <div class="position-relative">
                          <input v-model="searchTerm" @input="searchUsers" type="text" class="form-control" placeholder="Search users...">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8 text-end">
                      <button @click="refreshUsers" class="btn btn-light" :disabled="loading">
                        <i class="mdi mdi-refresh" :class="{ 'spin-animation': loading }"></i> Refresh
                      </button>
                    </div>
                  </div>

                  <div class="table-responsive">
                    <table class="table align-middle table-nowrap table-hover dt-responsive contacts-table" id="datatable-buttons">
                      <thead class="table-light text-uppercase">
                      <tr>
                        <th scope="col">System User</th>
                        <th scope="col">Contact</th>
                        <th scope="col">User Role</th>
                        <th scope="col">Department</th>
                        <th scope="col">Organization</th>
                        <th scope="col">Last Seen</th>
                        <th scope="col">Status</th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody class="text-uppercase">
                      <!-- Loading state -->
                      <tr v-if="loading && users.length === 0">
                        <td colspan="8" class="text-center py-4">
                          <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </td>
                      </tr>

                      <!-- No data state -->
                      <tr v-else-if="!loading && users.length === 0">
                        <td colspan="8" class="text-center py-4">
                          <p class="text-muted mb-0">No users found</p>
                        </td>
                      </tr>

                      <!-- User rows -->
                      <tr v-for="user in users" :key="user.user_id">
                        <td>
                          <a href="javascript: void(0);" @click="viewUserProfile(user.user_id)">
                            <div class="d-flex align-items-center">
                              <div class="avatar-xs mr-15px">
                                <span class="avatar-title rounded-circle bg-primary text-white">{{ getInitials(user.full_name) }}</span>
                              </div>
                              <div>
                                <h5 class="font-size-14 mb-1">
                                  <a href="javascript: void(0);" class="text-dark">{{ user.full_name }}</a>
                                </h5>
                                <p class="text-muted mb-0 font-size-12">
                                  <i class="mdi mdi-account-circle me-1"></i>{{ user.username }}
                                </p>
                              </div>
                            </div>
                          </a>
                        </td>
                        <td>
                          <div>
                            <p class="mb-1 font-size-13">
                              <i class="mdi mdi-email me-1 text-primary"></i>{{ user.email }}
                            </p>
                            <p class="mb-0 text-muted font-size-12">
                              <i class="mdi mdi-phone me-1"></i>{{ user.phone || 'N/A' }}
                            </p>
                          </div>
                        </td>
                        <td>
                          <span class="badge" :class="getCategoryBadgeClass(user.category)">
                            {{ user.category || 'N/A' }}
                          </span>
                          <small class="d-block text-muted mt-1">{{ getAccessScope(user.access_scope) }}</small>
                        </td>
                        <td>
                          <div>
                            <p class="mb-0 fw-bold">{{ user.department_name || 'N/A' }}</p>
                            <small class="text-muted">{{ user.employment_type_name || '' }}</small>
                          </div>
                        </td>
                        <td>
                          <div>
                            <p class="mb-1 font-size-12">{{ user.hospital_name || user.affiliation_name || 'N/A' }}</p>
                            <small class="text-muted" v-if="user.assigned_woreda_id">
                              <i class="mdi mdi-map-marker"></i> Woreda ID: {{ user.assigned_woreda_id }}
                            </small>
                          </div>
                        </td>
                        <td>
                          <div>
                            <p class="mb-0">{{ formatLastSeen(user.last_login) }}</p>
                            <small class="text-muted font-size-11">{{ formatDateTime(user.last_login) }}</small>
                          </div>
                        </td>
                        <td>
                          <p class="mb-2 text-truncate text-uppercase fw-bold">
                            <i :class="getStatusClass(user.is_active)" class="mdi mdi-circle me-1"></i>
                            {{ user.is_active == '1' ? 'Active' : 'Inactive' }}
                          </p>
                        </td>
                        <td>
                          <div class="dropdown">
                            <a class="text-muted font-size-16" role="button" data-bs-toggle="dropdown" aria-haspopup="true">
                              <i class="bx bx-dots-vertical-rounded"></i>
                            </a>
                            <div class="dropdown-menu dropdown-menu-end">
                              <a class="dropdown-item" href="javascript: void(0);" @click="viewUserProfile(user.user_id)">
                                <i class="font-size-15 mdi mdi-eye me-3"></i>View Profile
                              </a>
                              <a class="dropdown-item" href="javascript: void(0);" @click="showEditModal(user)">
                                <i class="font-size-15 mdi mdi-pencil me-3"></i>Edit Account
                              </a>
                              <a class="dropdown-item" href="javascript: void(0);" @click="showDeactivateModal(user)">
                                <i class="font-size-15 mdi mdi-account-off me-3"></i>
                                {{ user.is_active ? 'Deactivate' : 'Activate' }} Account
                              </a>
                              <a class="dropdown-item" href="javascript: void(0);" @click="resendLoginDetails(user)">
                                <i class="font-size-15 mdi mdi-email-send me-3"></i>Send Login Details
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Pagination -->
                    <div v-if="totalUsers > limit" class="row mt-3">
                      <div class="col-sm-12 col-md-5">
                        <div class="dataTables_info">
                          Showing {{ offset + 1 }} to {{ Math.min(offset + limit, totalUsers) }} of {{ totalUsers }} entries
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-7">
                        <div class="dataTables_paginate paging_simple_numbers">
                          <ul class="pagination">
                            <li class="paginate_button page-item previous" :class="{ disabled: offset === 0 }">
                              <a href="javascript: void(0);" @click.prevent="previousPage" class="page-link">Previous</a>
                            </li>
                            <li v-for="page in visiblePages" :key="page"
                                class="paginate_button page-item"
                                :class="{ active: page === currentPage }">
                              <a href="javascript: void(0);" @click.prevent="goToPage(page)" class="page-link">{{ page }}</a>
                            </li>
                            <li class="paginate_button page-item next" :class="{ disabled: offset + limit >= totalUsers }">
                              <a href="javascript: void(0);" @click.prevent="nextPage" class="page-link">Next</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>

            <!-- end row -->
          </div>
          <!-- container-fluid -->
        </div>
        <!-- End Page-content -->

        <!-- user account deactivation modal -->
        <div class="modal fade deactivate-user" :class="{ show: showDeactivateUserModal }"
             :style="{ display: showDeactivateUserModal ? 'block' : 'none' }"
             tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content modal-md">
              <div class="modal-header border-bottom-0">
                <h4 class="modal-title text-uppercase">{{ selectedUser?.is_active ? 'Deactivate' : 'Activate' }} User Account</h4>
                <button type="button" class="btn-close" @click="showDeactivateUserModal = false"></button>
              </div>
              <div class="modal-body">
                <p>Are you sure you want to {{ selectedUser?.is_active ? 'deactivate' : 'activate' }} the user account for
                  <strong class="text-primary">{{ selectedUser?.full_name }}</strong>?
                </p>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="deactivation-reason" class="form-label">
                      Reason for {{ selectedUser?.is_active ? 'Deactivation' : 'Activation' }}
                      <span class="text-danger">*</span>
                    </label>
                    <textarea v-model="deactivationReason"
                              id="deactivation-reason"
                              :placeholder="selectedUser?.is_active ? 'Provide detailed reason for deactivation (minimum 10 characters)' : 'Provide detailed reason for activation (minimum 10 characters)'"
                              class="form-control"
                              rows="3"
                              spellcheck="false"
                              minlength="10"
                              maxlength="500"
                              required></textarea>
                    <div class="d-flex justify-content-between mt-1">
                      <small v-if="deactivationReason.length > 0 && deactivationReason.length < 10" class="text-danger">
                        Reason must be at least 10 characters long
                      </small>
                      <small v-else-if="!deactivationReason" class="text-danger">
                        This field is required
                      </small>
                      <small v-else class="text-success">
                        Valid reason provided
                      </small>
                      <small class="text-muted">
                        {{ deactivationReason.length }}/500 characters
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <div class="d-flex flex-wrap gap-2 text-uppercase">
                  <button type="submit"
                          @click="confirmDeactivateUser"
                          :disabled="processingAction || !isReasonValid"
                          :class="selectedUser?.is_active ? 'btn-danger' : 'btn-success'"
                          class="btn waves-effect waves-light">
                    <span v-if="processingAction" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {{ processingAction ? 'Processing...' : (selectedUser?.is_active ? 'Confirm Deactivation' : 'Confirm Activation') }}
                  </button>
                  <button type="button" class="btn btn-secondary waves-effect"
                          @click="showDeactivateUserModal = false" :disabled="processingAction">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- /.modal-dialog -->
        </div>

        <!-- Modal backdrop -->
        <div v-if="showDeactivateUserModal" class="modal-backdrop fade show"></div>

        <!-- Edit User Modal Component -->
        <EditUserModal
            :visible="showEditUserModal"
            :user="selectedUser"
            :roles="roles"
            :departments="departments"
            :hospitals="hospitals"
            @close="closeEditModal"
            @update-success="onUserUpdateSuccess"
        />

        <!-- User Profile Modal -->
        <div class="modal fade view-user-profile" :class="{ show: showProfileModal }"
             :style="{ display: showProfileModal ? 'block' : 'none' }"
             tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title text-uppercase">User Profile</h4>
                <button type="button" class="btn-close" @click="closeProfileModal"></button>
              </div>
              <div class="modal-body p-0">
                <div v-if="loadingProfile" class="text-center py-5">
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>

                <div v-else-if="profileData" class="d-flex h-100">
                  <!-- Left Sidebar -->
                  <div class="profile-sidebar bg-light p-4">
                    <div class="text-center mb-4">
                      <div class="avatar-xl mx-auto mb-3">
                      <span class="avatar-title rounded-circle bg-primary-subtle text-primary font-size-24">
                        {{ getInitials(profileData.user.full_name) }}
                      </span>
                      </div>
                      <h5 class="font-size-16 mb-1">{{ profileData.user.full_name }}</h5>
                      <p class="text-muted mb-2">{{ profileData.user.category }}</p>
                      <span class="badge" :class="profileData.user.is_active == '1' ? 'bg-success' : 'bg-danger'">
                      {{ profileData.user.is_active == '1' ? 'Active' : 'Inactive' }}
                    </span>
                    </div>

                    <div class="border-top pt-4" v-if="profileData && profileData.user">
                      <h6 class="text-uppercase text-muted mb-3">Quick Actions</h6>
                      <div class="d-grid gap-2">
                        <button class="btn btn-sm btn-outline-primary" @click="showEditModalFromProfile">
                          <i class="mdi mdi-pencil me-1"></i> Edit User
                        </button>
                        <button class="btn btn-sm btn-outline-warning" @click="resetPasswordFromProfile">
                          <i class="mdi mdi-lock-reset me-1"></i> Reset Password
                        </button>
                        <button class="btn btn-sm"
                                :class="profileData.user.is_active ? 'btn-outline-danger' : 'btn-outline-success'"
                                @click="toggleStatusFromProfile">
                          <i class="mdi" :class="profileData.user.is_active ? 'mdi-account-off' : 'mdi-account-check'"></i>
                          {{ profileData.user.is_active ? 'Deactivate' : 'Activate' }}
                        </button>
                      </div>
                    </div>

                    <div class="border-top pt-4 mt-4" v-if="profileData && profileData.user">
                      <h6 class="text-uppercase text-muted mb-3">Contact Info</h6>
                      <p class="mb-2"><i class="mdi mdi-email me-2"></i>{{ profileData.user.email }}</p>
                      <p class="mb-2" v-if="profileData.user.phone"><i class="mdi mdi-phone me-2"></i>{{ profileData.user.phone }}</p>
                      <p class="mb-0" v-if="profileData.user.employee_id"><i class="mdi mdi-badge-account me-2"></i>{{ profileData.user.employee_id }}</p>
                    </div>
                  </div>

                  <!-- Right Content -->
                  <div class="profile-content flex-grow-1 p-4 overflow-auto">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link active" data-bs-toggle="tab" href="#general-info" role="tab">
                          <span class="d-none d-sm-block">General Information</span>
                          <span class="d-block d-sm-none"><i class="mdi mdi-account"></i></span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#work-info" role="tab">
                          <span class="d-none d-sm-block">Work Information</span>
                          <span class="d-block d-sm-none"><i class="mdi mdi-briefcase"></i></span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#account-activity" role="tab">
                          <span class="d-none d-sm-block">Account Activity</span>
                          <span class="d-block d-sm-none"><i class="mdi mdi-history"></i></span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#activity-timeline" role="tab">
                          <span class="d-none d-sm-block">Activity Timeline</span>
                          <span class="d-block d-sm-none"><i class="mdi mdi-timeline"></i></span>
                        </a>
                      </li>
                    </ul>

                    <!-- Tab panes -->
                    <div class="tab-content pt-4">
                      <!-- General Information -->
                      <div class="tab-pane active" id="general-info" role="tabpanel">
                        <div class="row">
                          <div class="col-md-6">
                            <h5 class="font-size-15 mb-4">Personal Details</h5>
                            <div class="table-responsive">
                              <table class="table table-borderless mb-0">
                                <tbody>
                                <tr>
                                  <th scope="row" width="40%">Full Name:</th>
                                  <td>{{ profileData.user.full_name }}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Username:</th>
                                  <td>{{ profileData.user.username }}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Email:</th>
                                  <td>{{ profileData.user.email }}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Phone:</th>
                                  <td>{{ profileData.user.phone || 'Not provided' }}</td>
                                </tr>
                                <tr v-if="profileData.user.employment_details_parsed">
                                  <th scope="row">Gender:</th>
                                  <td>{{ profileData.user.employment_details_parsed.gender || 'Not specified' }}</td>
                                </tr>
                                <tr v-if="profileData.user.employment_details_parsed">
                                  <th scope="row">Date of Birth:</th>
                                  <td>{{ formatDateOnly(profileData.user.employment_details_parsed.date_of_birth) || 'Not provided' }}</td>
                                </tr>
                                <tr v-if="profileData.user.employment_details_parsed">
                                  <th scope="row">National ID:</th>
                                  <td>{{ profileData.user.employment_details_parsed.national_id || 'Not provided' }}</td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                          <div class="col-md-6">
                            <h5 class="font-size-15 mb-4">Account Information</h5>
                            <div class="table-responsive">
                              <table class="table table-borderless mb-0">
                                <tbody>
                                <tr>
                                  <th scope="row" width="40%">User ID:</th>
                                  <td>{{ profileData.user.user_id }}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Account Status:</th>
                                  <td>
                                      <span class="badge" :class="profileData.user.is_active ? 'bg-success' : 'bg-danger'">
                                        {{ profileData.user.is_active ? 'Active' : 'Inactive' }}
                                      </span>
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">Created Date:</th>
                                  <td>{{ formatDateOnly(profileData.user.created_at) }}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Created By:</th>
                                  <td>{{ profileData.user.created_by_full_name || profileData.user.created_by_username || 'System' }}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Last Updated:</th>
                                  <td>{{ formatDate(profileData.user.updated_at) }}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Last Login:</th>
                                  <td>{{ formatDate(profileData.user.last_login) || 'Never' }}</td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        <!-- Employment Details -->
                        <div class="row mt-4" v-if="profileData.user.employment_details_parsed">
                          <div class="col-12">
                            <h5 class="font-size-15 mb-4">Additional Information</h5>
                            <div class="p-3 bg-light rounded">
                              <p class="mb-2" v-if="profileData.user.employment_details_parsed.title">
                                <strong>Title:</strong> {{ profileData.user.employment_details_parsed.title }}
                              </p>
                              <p class="mb-0" v-if="profileData.user.employment_details_parsed.notes">
                                <strong>Notes:</strong> {{ profileData.user.employment_details_parsed.notes }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Work Information -->
                      <div class="tab-pane" id="work-info" role="tabpanel">
                        <div class="row">
                          <div class="col-md-6">
                            <h5 class="font-size-15 mb-4">Position & Department</h5>
                            <div class="table-responsive">
                              <table class="table table-borderless mb-0">
                                <tbody>
                                <tr>
                                  <th scope="row" width="40%">Role:</th>
                                  <td>{{ profileData.user.role_name }}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Organization Level:</th>
                                  <td>{{ profileData.user.level_name }}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Department:</th>
                                  <td>{{ profileData.user.department_name || 'Not assigned' }}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Employment Type:</th>
                                  <td>{{ profileData.user.employment_type_name || 'Not specified' }}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Employee ID:</th>
                                  <td>{{ profileData.user.employee_id || 'Not assigned' }}</td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                          <div class="col-md-6">
                            <h5 class="font-size-15 mb-4">Assignment & Access</h5>
                            <div class="table-responsive">
                              <table class="table table-borderless mb-0">
                                <tbody>
                                <tr>
                                  <th scope="row" width="40%">Access Scope:</th>
                                  <td class="text-capitalize">{{ profileData.user.access_scope }}</td>
                                </tr>
                                <tr v-if="profileData.user.hospital_name">
                                  <th scope="row">Hospital:</th>
                                  <td>{{ profileData.user.hospital_name }}</td>
                                </tr>
                                <tr v-if="profileData.user.region_name">
                                  <th scope="row">Region:</th>
                                  <td>{{ profileData.user.region_name }}</td>
                                </tr>
                                <tr v-if="profileData.user.zone_name">
                                  <th scope="row">Zone:</th>
                                  <td>{{ profileData.user.zone_name }}</td>
                                </tr>
                                <tr v-if="profileData.user.woreda_name">
                                  <th scope="row">Woreda:</th>
                                  <td>{{ profileData.user.woreda_name }}</td>
                                </tr>
                                <tr v-if="profileData.user.affiliation_name">
                                  <th scope="row">Affiliation:</th>
                                  <td>{{ profileData.user.affiliation_name }}</td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        <!-- Permissions -->
                        <div class="row mt-4" v-if="profileData.permissions && profileData.permissions.length > 0">
                          <div class="col-12">
                            <h5 class="font-size-15 mb-4">Permissions</h5>
                            <div class="table-responsive">
                              <table class="table table-bordered table-sm">
                                <thead>
                                <tr>
                                  <th>Module</th>
                                  <th>Permission</th>
                                  <th>Description</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="permission in profileData.permissions" :key="permission.permission_id">
                                  <td>{{ permission.module }}</td>
                                  <td>{{ permission.permission_name }}</td>
                                  <td>{{ permission.description }}</td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Account Activity -->
                      <div class="tab-pane" id="account-activity" role="tabpanel">
                        <div class="row">
                          <div class="col-md-6">
                            <h5 class="font-size-15 mb-4">Activity Summary</h5>
                            <div class="card">
                              <div class="card-body">
                                <div class="d-flex justify-content-between mb-3">
                                  <span>Total Activities (30 days):</span>
                                  <strong>{{ profileData.activitySummary?.total_activities || 0 }}</strong>
                                </div>
                                <div class="d-flex justify-content-between mb-3">
                                  <span>Modules Accessed:</span>
                                  <strong>{{ profileData.activitySummary?.modules_accessed || 0 }}</strong>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <span>Last Activity:</span>
                                  <strong>{{ formatDate(profileData.activitySummary?.last_activity) || 'None' }}</strong>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-md-6">
                            <h5 class="font-size-15 mb-4">Login History</h5>
                            <div class="table-responsive">
                              <table class="table table-sm">
                                <thead>
                                <tr>
                                  <th>Date</th>
                                  <th>Time</th>
                                  <th>IP Address</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="login in profileData.loginHistory" :key="login.attempt_id">
                                  <td>{{ formatDateOnly(login.attempt_time) }}</td>
                                  <td>{{ formatTimeOnly(login.attempt_time) }}</td>
                                  <td>{{ login.ip_address }}</td>
                                </tr>
                                <tr v-if="(!profileData.loginHistory || profileData.loginHistory.length === 0)">
                                  <td colspan="3" class="text-center text-muted">No login history available</td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        <!-- Account Metadata -->
                        <div class="row mt-4">
                          <div class="col-12">
                            <h5 class="font-size-15 mb-4">Account Metadata</h5>
                            <div class="table-responsive">
                              <table class="table table-bordered">
                                <tbody>
                                <tr>
                                  <th width="30%">Password Changed At:</th>
                                  <td>{{ formatDate(profileData.user.password_changed_at) || 'Never' }}</td>
                                </tr>
                                <tr>
                                  <th>Must Change Password:</th>
                                  <td>
                                      <span class="badge" :class="profileData.user.must_change_password ? 'bg-warning' : 'bg-success'">
                                        {{ profileData.user.must_change_password ? 'Yes' : 'No' }}
                                      </span>
                                  </td>
                                </tr>
                                <tr>
                                  <th>Failed Login Attempts:</th>
                                  <td>{{ profileData.user.failed_login_attempts || 0 }}</td>
                                </tr>
                                <tr v-if="profileData.user.locked_until">
                                  <th>Locked Until:</th>
                                  <td>{{ formatDate(profileData.user.locked_until) }}</td>
                                </tr>
                                <tr>
                                  <th>Activation Date:</th>
                                  <td>{{ formatDateOnly(profileData.user.activation_date) || 'Not set' }}</td>
                                </tr>
                                <tr v-if="profileData.user.deactivation_date">
                                  <th>Deactivation Date:</th>
                                  <td>{{ formatDateOnly(profileData.user.deactivation_date) }}</td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Activity Timeline -->
                      <div class="tab-pane" id="activity-timeline" role="tabpanel">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="font-size-15 mb-4">Recent Activity Timeline</h5>

                            <div v-if="loadingTimeline" class="text-center py-4">
                              <div class="spinner-border text-primary spinner-border-sm" role="status">
                                <span class="sr-only">Loading timeline...</span>
                              </div>
                            </div>

                            <div v-else-if="activityTimeline && activityTimeline.length > 0" class="timeline">
                              <div v-for="(activity, index) in activityTimeline" :key="index" class="timeline-item">
                                <div class="timeline-marker"></div>
                                <div class="timeline-content">
                                  <h6 class="timeline-title">{{ activity.action }}</h6>
                                  <p class="text-muted mb-1">{{ activity.description }}</p>
                                  <small class="text-muted">
                                    <i class="mdi mdi-clock-outline"></i> {{ formatDate(activity.created_at) }}
                                  </small>
                                </div>
                              </div>
                            </div>

                            <div v-else class="text-center py-4">
                              <p class="text-muted">No activity timeline available</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal backdrop for profile -->
      <div v-if="showProfileModal" class="modal-backdrop fade show"></div>

    </div>
    <!-- end main content-->

  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>

  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import EditUserModal from "@/components/cbhi-users/modals/EditUserModal.vue";
import { authUrl, executeJson } from "@/api";

export default {
  name: "UserList",
  components: {
    NavigationBar,
    EditUserModal
  },
  data() {
    return {
      loading: false,
      processingAction: false,
      users: [],
      totalUsers: 0,
      limit: 10,
      offset: 0,
      searchTerm: '',
      searchTimeout: null,
      showDeactivateUserModal: false,
      showEditUserModal: false,
      showProfileModal: false,
      selectedUser: null,
      deactivationReason: '',

      // Profile data
      profileData: null,
      loadingProfile: false,
      activityTimeline: [],
      loadingTimeline: false,

      // Dropdown data
      roles: [],
      departments: [],
      hospitals: [],

      // Alert states
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: ''
    };
  },

  computed: {
    currentPage() {
      return Math.floor(this.offset / this.limit) + 1;
    },

    totalPages() {
      return Math.ceil(this.totalUsers / this.limit);
    },

    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      const halfVisible = Math.floor(maxVisible / 2);

      let start = Math.max(1, this.currentPage - halfVisible);
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      if (end - start < maxVisible - 1) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },

    // Validation for deactivation reason
    isReasonValid() {
      const reason = this.deactivationReason.trim();
      return reason.length >= 10 && reason.length <= 500;
    }
  },

  mounted() {
    this.fetchUsers();
    this.fetchDropdownData();
  },

  methods: {
    // Fetch users from API
    async fetchUsers() {
      this.loading = true;
      this.clearAlerts();

      const data = {
        function: "getUsers",
        status: "active",
        searchTerm: this.searchTerm,
        limit: this.limit,
        offset: this.offset
      };

      try {
        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.users = response.data.data.users || [];
          this.totalUsers = response.data.data.total || 0;
        } else {
          this.showAlert('failed', response.data.message || 'Failed to fetch users');
          this.users = [];
        }
      } catch (error) {
        this.showAlert('failed', error.message || 'An error occurred while fetching users');
        this.users = [];
      } finally {
        this.loading = false;
      }
    },

    // Search users with debounce
    searchUsers() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.offset = 0; // Reset to first page
        this.fetchUsers();
      }, 500); // 500ms debounce
    },

    // Refresh users list
    refreshUsers() {
      this.searchTerm = '';
      this.offset = 0;
      this.fetchUsers();
    },

    // View user profile
    async viewUserProfile(userId) {
      this.showProfileModal = true;
      this.loadingProfile = true;
      this.profileData = null;

      try {
        const response = await executeJson({
          function: "getUserDetails",
          userId: userId
        }, authUrl);

        if (response.data.success && response.data.data) {
          this.profileData = response.data.data;

          // Load activity timeline
          this.loadActivityTimeline(userId);
        } else {
          this.showAlert('failed', response.data.message || 'Failed to load user profile');
          this.closeProfileModal();
        }
      } catch (error) {
        this.showAlert('failed', error.message || 'An error occurred while loading profile');
        this.closeProfileModal();
      } finally {
        this.loadingProfile = false;
      }
    },

    // Load activity timeline
    async loadActivityTimeline(userId) {
      this.loadingTimeline = true;
      this.activityTimeline = [];

      try {
        const response = await executeJson({
          function: "getActivityLogs",
          userId: userId,
          limit: 20
        }, authUrl);

        if (response.data.success && response.data.data) {
          this.activityTimeline = response.data.data.logs || [];
        }
      } catch (error) {
        console.error('Error loading activity timeline:', error);
      } finally {
        this.loadingTimeline = false;
      }
    },

    // Close profile modal
    closeProfileModal() {
      this.showProfileModal = false;
      this.profileData = null;
      this.activityTimeline = [];
    },

    // Show edit modal from profile
    showEditModalFromProfile() {
      // Check if profile data and user exist
      if (!this.profileData) {
        console.error('Profile data is null');
        this.showAlert('failed', 'Profile data not loaded. Please try again.');
        return;
      }

      if (!this.profileData.user) {
        console.error('User data is null in profile');
        this.showAlert('failed', 'User data not available. Please try again.');
        return;
      }

      // Store user data before closing modal to prevent null reference
      const userData = JSON.parse(JSON.stringify(this.profileData.user));
      console.log('Editing user from profile:', userData);

      this.closeProfileModal(); // Close profile modal first
      this.showEditModal(userData);
    },

    // Reset password from profile
    async resetPasswordFromProfile() {
      if (!this.profileData || !this.profileData.user) return;

      if (confirm(`Reset password for ${this.profileData.user.full_name}?`)) {
        await this.resetUserPassword(this.profileData.user);
      }
    },

    // Toggle status from profile
    toggleStatusFromProfile() {
      if (this.profileData && this.profileData.user) {
        this.showDeactivateModal(this.profileData.user);
      }
    },

    // Reset user password
    async resetUserPassword(user) {
      this.clearAlerts();

      const data = {
        function: "resetUserPassword",
        userId: user.user_id
      };

      try {
        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.showAlert('success', response.data.message || 'Password reset successfully');
        } else {
          this.showAlert('failed', response.data.message || 'Failed to reset password');
        }
      } catch (error) {
        this.showAlert('failed', error.message || 'An error occurred');
      }
    },

    // Pagination methods
    previousPage() {
      if (this.offset > 0) {
        this.offset = Math.max(0, this.offset - this.limit);
        this.fetchUsers();
      }
    },

    nextPage() {
      if (this.offset + this.limit < this.totalUsers) {
        this.offset += this.limit;
        this.fetchUsers();
      }
    },

    goToPage(page) {
      this.offset = (page - 1) * this.limit;
      this.fetchUsers();
    },

    // Show deactivate/activate modal
    showDeactivateModal(user) {
      this.selectedUser = user;
      this.deactivationReason = '';
      this.showDeactivateUserModal = true;
    },

    // Confirm deactivate/activate user
    async confirmDeactivateUser() {
      if (!this.selectedUser) return;

      // Validate that reason is provided and meets minimum length
      const reason = this.deactivationReason.trim();
      if (!reason) {
        this.showAlert('failed', 'Please provide a reason for this action');
        return;
      }

      if (reason.length < 10) {
        this.showAlert('failed', 'Reason must be at least 10 characters long');
        return;
      }

      if (reason.length > 500) {
        this.showAlert('failed', 'Reason cannot exceed 500 characters');
        return;
      }

      // Additional validation for meaningful content
      if (!/[a-zA-Z]/.test(reason)) {
        this.showAlert('failed', 'Reason must contain meaningful text, not just numbers or symbols');
        return;
      }

      this.processingAction = true;
      this.clearAlerts();

      const data = {
        function: "deactivateUser",
        userId: this.selectedUser.user_id,
        reason: reason
      };

      try {
        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.showAlert('success', response.data.message || 'User status updated successfully');
          this.showDeactivateUserModal = false;
          this.selectedUser = null;
          this.deactivationReason = '';

          // Refresh the users list
          this.fetchUsers();

          // If profile is open, close it
          if (this.showProfileModal) {
            this.closeProfileModal();
          }
        } else {
          this.showAlert('failed', response.data.message || 'Failed to update user status');
        }
      } catch (error) {
        this.showAlert('failed', error.message || 'An error occurred');
      } finally {
        this.processingAction = false;
      }
    },

    // Resend login details
    async resendLoginDetails(user) {
      if (!confirm(`Send login details to ${user.full_name}?`)) {
        return;
      }

      this.clearAlerts();

      const data = {
        function: "resetUserPassword",
        userId: user.user_id
      };

      try {
        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.showAlert('success', response.data.message || 'Login details sent successfully');
        } else {
          this.showAlert('failed', response.data.message || 'Failed to send login details');
        }
      } catch (error) {
        this.showAlert('failed', error.message || 'An error occurred');
      }
    },

    // Helper methods
    getInitials(fullName) {
      if (!fullName) return 'U';
      const names = fullName.trim().split(' ');
      if (names.length >= 2) {
        return names[0].charAt(0).toUpperCase() + names[names.length - 1].charAt(0).toUpperCase();
      }
      return names[0].charAt(0).toUpperCase();
    },

    getCategoryBadgeClass(category) {
      const classes = {
        'ADMIN': 'bg-danger',
        'DOCTOR': 'bg-primary',
        'NURSE': 'bg-info',
        'PHARMACIST': 'bg-success',
        'ACCOUNTANT': 'bg-warning',
        'RECEPTIONIST': 'bg-secondary'
      };
      return classes[category] || 'bg-secondary';
    },

    getStatusClass(isActive) {
      return isActive == '1' ? 'text-success' : 'text-danger';
    },

    formatLastSeen(lastLogin) {
      if (!lastLogin) return 'Never';

      const date = new Date(lastLogin);
      const now = new Date();
      const diffMs = now - date;
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMs / 3600000);
      const diffDays = Math.floor(diffMs / 86400000);

      if (diffMins < 1) return 'Just now';
      if (diffMins < 60) return `${diffMins} min${diffMins > 1 ? 's' : ''} ago`;
      if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
      if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;

      return date.toLocaleDateString();
    },

    formatDateTime(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    getAccessScope(scope) {
      const scopes = {
        'national': 'National Level',
        'regional': 'Regional Level',
        'zonal': 'Zonal Level',
        'woreda': 'Woreda Level',
        'facility': 'Facility Level',
        'kebele': 'Kebele Level'
      };
      return scopes[scope] || scope;
    },

    formatDate(dateString) {
      if (!dateString) return null;

      const date = new Date(dateString);
      const now = new Date();
      const diffMs = now - date;
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMs / 3600000);
      const diffDays = Math.floor(diffMs / 86400000);

      if (diffMins < 1) return 'Just now';
      if (diffMins < 60) return `${diffMins} min${diffMins > 1 ? 's' : ''} ago`;
      if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
      if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;

      // Format as date if older than 7 days
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    formatDateOnly(dateString) {
      if (!dateString) return null;

      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    },

    formatTimeOnly(dateString) {
      if (!dateString) return null;

      const date = new Date(dateString);
      return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    clearAlerts() {
      this.alert.success = false;
      this.alert.info = false;
      this.alert.failed = false;
      this.message = '';
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;

      // Auto-hide success/info alerts after 5 seconds
      if (type === 'success' || type === 'info') {
        setTimeout(() => {
          this.clearAlerts();
        }, 5000);
      }
    },

    // Edit modal methods
    async fetchDropdownData() {
      // Fetch roles with proper nested data access
      // Response structure: { data: { rights: [{ type: {...}, roles: [...] }] } }
      try {
        const rolesResponse = await executeJson({ function: "getRoles" }, authUrl);

        if (rolesResponse.data && rolesResponse.data.success) {
          // Access the roles from rights array structure
          if (rolesResponse.data.data && rolesResponse.data.data.rights && rolesResponse.data.data.rights.length > 0) {
            // Flatten all roles from all rights entries
            this.roles = rolesResponse.data.data.rights.flatMap(right => right.roles || []);
            console.log(`Loaded ${this.roles.length} roles successfully`);
          } else if (rolesResponse.data.data && rolesResponse.data.data.roles) {
            // Alternative structure: direct roles array
            this.roles = rolesResponse.data.data.roles;
            console.log(`Loaded ${this.roles.length} roles successfully`);
          } else {
            console.error('Unexpected roles response structure:', rolesResponse.data);
            this.roles = [];
          }
        } else {
          console.error('Failed to fetch roles:', rolesResponse.data?.message);
          this.roles = [];
        }
      } catch (error) {
        console.error('Error fetching roles:', error);
        this.roles = [];
      }

      // Fetch departments - structure: { data: { departments: [...] } }
      try {
        const deptsResponse = await executeJson({ function: "getDepartments" }, authUrl);

        if (deptsResponse.data && deptsResponse.data.success) {
          if (deptsResponse.data.data && deptsResponse.data.data.departments) {
            this.departments = deptsResponse.data.data.departments;
          } else {
            console.error('Unexpected departments response structure:', deptsResponse.data);
            this.departments = [];
          }
          console.log(`Loaded ${this.departments.length} departments successfully`);
        } else {
          console.error('Failed to fetch departments:', deptsResponse.data?.message);
          this.departments = [];
        }
      } catch (error) {
        console.error('Error fetching departments:', error);
        this.departments = [];
      }

      // Fetch hospitals - structure: { data: { hospitals: [...] } }
      try {
        const hospitalsResponse = await executeJson({ function: "getHospitals" }, authUrl);

        if (hospitalsResponse.data && hospitalsResponse.data.success) {
          if (hospitalsResponse.data.data && hospitalsResponse.data.data.hospitals) {
            this.hospitals = hospitalsResponse.data.data.hospitals;
          } else {
            console.error('Unexpected hospitals response structure:', hospitalsResponse.data);
            this.hospitals = [];
          }
          console.log(`Loaded ${this.hospitals.length} hospitals successfully`);
        } else {
          console.error('Failed to fetch hospitals:', hospitalsResponse.data?.message);
          this.hospitals = [];
        }
      } catch (error) {
        console.error('Error fetching hospitals:', error);
        this.hospitals = [];
      }
    },

    async showEditModal(user) {
      // Ensure dropdown data is loaded before showing modal
      if (this.roles.length === 0 || this.departments.length === 0) {
        console.log('Loading dropdown data before showing modal...');
        await this.fetchDropdownData();
      }

      this.selectedUser = user;
      this.showEditUserModal = true;

      // Log to verify data is available
      console.log('Opening edit modal with:', {
        rolesCount: this.roles.length,
        departmentsCount: this.departments.length,
        hospitalsCount: this.hospitals.length,
        user: user
      });
    },

    closeEditModal() {
      this.showEditUserModal = false;
      this.selectedUser = null;
    },

    onUserUpdateSuccess(data) {
      this.showAlert('success', data?.message || 'User updated successfully');
      this.fetchUsers();
      this.fetchDropdownData();

      // If profile is open for this user, refresh it
      if (this.showProfileModal && this.profileData && data?.userId &&
          this.profileData.user.user_id === data.userId) {
        this.viewUserProfile(data.userId);
      }
    }
  }
};
</script>

<style scoped>
/* Search box styles */
.search-box .form-control {
  border-radius: 30px;
  padding-left: 40px;
}

.search-box .search-icon {
  position: absolute;
  left: 13px;
  top: 12px;
  font-size: 16px;
  color: #74788d;
}

/* Spin animation for refresh button */
.spin-animation {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Modal styles */
.modal.show {
  display: block !important;
}

.modal-backdrop {
  z-index: 1040;
}

.modal {
  z-index: 1050;
}

.modal-xl {
  max-width: 1140px;
}

@media (min-width: 1400px) {
  .modal-xl {
    max-width: 1320px;
  }
}

/* Profile modal specific styles */
.view-user-profile .modal-dialog {
  height: 90vh;
  margin: 1.75rem 1.75rem 1.75rem auto;
  max-width: 1140px;
}

.view-user-profile .modal-body {
  padding: 0;
  height: calc(100% - 56px);
  overflow: hidden;
}

.profile-sidebar {
  width: 300px;
  min-width: 300px;
  border-right: 1px solid #e3e6f0;
  overflow-y: auto;
}

.profile-content {
  position: relative;
  width: 100%;
}

/* Ensure flex layout works properly */
.view-user-profile .d-flex {
  display: flex !important;
}

.view-user-profile .flex-grow-1 {
  flex-grow: 1 !important;
}

/* Scrollbar for sidebar and content */
.profile-sidebar::-webkit-scrollbar,
.profile-content::-webkit-scrollbar {
  width: 6px;
}

.profile-sidebar::-webkit-scrollbar-track,
.profile-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.profile-sidebar::-webkit-scrollbar-thumb,
.profile-content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.profile-sidebar::-webkit-scrollbar-thumb:hover,
.profile-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Avatar styles */
.avatar-xs {
  height: 2rem;
  width: 2rem;
}

.avatar-xl {
  height: 5rem;
  width: 5rem;
}

.avatar-title {
  align-items: center;
  background-color: #556ee6;
  color: #fff;
  display: inline-flex;
  font-weight: 500;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.bg-primary-subtle {
  background-color: rgba(85, 110, 230, 0.1);
}

.text-primary {
  color: #556ee6 !important;
}

/* Responsive adjustments */
@media (max-width: 991px) {
  .profile-sidebar {
    width: 250px;
    min-width: 250px;
  }
}

@media (max-width: 768px) {
  .view-user-profile .modal-body {
    flex-direction: column !important;
  }

  .profile-sidebar {
    width: 100%;
    min-width: 100%;
    border-right: none;
    border-bottom: 1px solid #e3e6f0;
    max-height: 300px;
  }

  .profile-content {
    width: 100%;
  }
}

.mr-15px {
  margin-right: 15px;
}

/* Table styles */
.table > tbody > tr > td {
  vertical-align: middle;
}

/* Pagination styles */
.pagination {
  margin-bottom: 0;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
}

.page-item.active .page-link {
  background-color: #556ee6;
  border-color: #556ee6;
}

/* Alert styles */
.alert {
  border-radius: 0.25rem;
  margin-bottom: 1rem;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

/* Timeline styles */
.timeline {
  position: relative;
  padding-left: 40px;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 15px;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #e3e6f0;
}

.timeline-item {
  position: relative;
  padding-bottom: 30px;
}

.timeline-item:last-child {
  padding-bottom: 0;
}

.timeline-marker {
  position: absolute;
  left: -25px;
  top: 0;
  width: 12px;
  height: 12px;
  background-color: #556ee6;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: 0 0 0 4px rgba(85, 110, 230, 0.1);
}

.timeline-content {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 5px;
  position: relative;
}

.timeline-content::before {
  content: '';
  position: absolute;
  left: -8px;
  top: 15px;
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 8px solid #f8f9fa;
}

.timeline-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
  color: #495057;
}

/* Tab styles */
.nav-tabs-custom .nav-item .nav-link {
  border: none;
  color: #74788d;
}

.nav-tabs-custom .nav-item .nav-link.active {
  color: #556ee6;
  background-color: transparent;
  border-bottom: 2px solid #556ee6;
}

/* Table responsive styles */
.table-responsive {
  min-height: auto;
}

/* Badge styles */
.badge {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 500;
}

/* Card styles */
.card {
  border: 1px solid #e3e6f0;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

/* Button styles in profile */
.view-user-profile .btn-outline-primary {
  color: #556ee6;
  border-color: #556ee6;
}

.view-user-profile .btn-outline-primary:hover {
  background-color: #556ee6;
  color: #fff;
}

.view-user-profile .btn-outline-warning {
  color: #f1b44c;
  border-color: #f1b44c;
}

.view-user-profile .btn-outline-warning:hover {
  background-color: #f1b44c;
  color: #fff;
}

.view-user-profile .btn-outline-danger {
  color: #f46a6a;
  border-color: #f46a6a;
}

.view-user-profile .btn-outline-danger:hover {
  background-color: #f46a6a;
  color: #fff;
}

.view-user-profile .btn-outline-success {
  color: #34c38f;
  border-color: #34c38f;
}

.view-user-profile .btn-outline-success:hover {
  background-color: #34c38f;
  color: #fff;
}

/* Deactivation modal specific styles */
.deactivate-user .form-control:invalid {
  border-color: #dc3545;
}

.deactivate-user .text-danger {
  font-size: 0.875rem;
}

/* Button disabled state when reason is empty */
.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

/* Enhanced validation styling */
.form-control:focus:invalid {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.form-control:focus:valid {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
</style>